(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calvea-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cv-hero__media').forEach(function (media) {
  var slides = media.querySelectorAll('[data-video-slide]');
    if (slides.length < 2) return;
      var current = 0;
        slides.forEach(function (slide) {
            var video = slide.querySelector('video');
                if (!video) return;
                    video.loop = false;
                        video.addEventListener('ended', function () {
                              slides[current].classList.remove('is-active');
                                    current = (current + 1) % slides.length;
                                          var nextSlide = slides[current];
                                                nextSlide.classList.add('is-active');
                                                      var nextVideo = nextSlide.querySelector('video');
                                                            if (nextVideo) {
                                                                    nextVideo.currentTime = 0;
                                                                            nextVideo.play();
                                                                                  }
                                                                                      });
                                                                                        });
                                                                                        });
                                                                                        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
